import { call, put, takeLatest } from "redux-saga/effects";
import { DealerLastUpdatedActionTypes } from "./actionTypes";
import {
    getDealerLastUpdatedListSuccess,
    getDealerLastUpdatedListError,
    getDealerDropdownListSuccess,
    getDealerDropdownListError,
    getEmployeeDropdownListSuccess,
    getEmployeeDropdownListError,
    getManufacturerDropdownListSuccess,
    getManufacturerDropdownListError,
} from "./actions";
import { API } from "src/util/api";

function* getDealerLastUpdatedListAsync(action: any) {
    try {
        const response: Promise<any> = yield call(API.getDealerLastUpdatedListAPI, {
            ...action.lazyState,
        });
        yield put(getDealerLastUpdatedListSuccess(response));
    } catch (error) {
        yield put(getDealerLastUpdatedListError(error));
    }
}

function* getDealerDropdownListAsync() {
    try {
        const response: Promise<any> = yield call(API.getDealerDropdownApi);
        yield put(getDealerDropdownListSuccess(response));
    } catch (error) {
        yield put(getDealerDropdownListError(error));
    }
}

function* getEmployeeDropdownListAsync() {
    try {
        const response: Promise<any> = yield call(API.getEmployeeDropdownForJobAPI);
        yield put(getEmployeeDropdownListSuccess(response));
    } catch (error) {
        yield put(getEmployeeDropdownListError(error));
    }
}

function* getManufacturerDropdownListAsync() {
    try {
        const response: Promise<any> = yield call(API.getManufacturerDropdown);
        yield put(getManufacturerDropdownListSuccess(response));
    } catch (error) {
        yield put(getManufacturerDropdownListError(error));
    }
}

function* DealerLastUpdatedSaga() {
    yield takeLatest(DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST, getDealerLastUpdatedListAsync);
    yield takeLatest(DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST, getDealerDropdownListAsync);
    yield takeLatest(DealerLastUpdatedActionTypes.GET_EMPLOYEE_DROPDOWN_LIST, getEmployeeDropdownListAsync);
    yield takeLatest(DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST, getManufacturerDropdownListAsync);
}

export default DealerLastUpdatedSaga;
